module.exports = __webpack_public_path__ + "img/text-carousel.e592be7e.png";